<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Cronomit Billiard</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col>
        <div id="content1">

          <div id="menu" class="row" style="text-align: center;">

            <!--ion-button [color]="menu!=1 ? 'light' : 'primary'" (click)="menuChange(1)" style="min-width: 100px;" disabled>
              <div class="custom-button-content">
                <img src="assets/icon/icons8-activity-history-96.png" width="50px">
                <span>Adatszolgáltatás<br>
                  <select name="nezet" style="visibility: hidden;">
                    <option value="0">-</option>
                  </select>
                </span>
              </div>
            </ion-button-->
            <ion-button [color]="menu!=0 ? 'light' : 'primary'" disabled>
              <div class="custom-button-content">
                <img src="assets/icon/icons8-product-documents-96.png" width="50px">
                <span>Törzsadatok<br>
                  <select name="nezet" [(ngModel)]="menu" (change)="menuChange(0)">
                    <option value="0">-</option>
                    <option value="2" disabled>Partnertörzs</option>
                    <option value="3" disabled>Számlatükör</option>
                    <option value="4" disabled>Eseménykönyvelés</option>
                    <option value="5" disabled>Munkaszám törzs</option>
                    <option value="6" disabled>Levélsablon</option>
                    <option value="7" disabled>NAV online</option>
                    <option value="8" disabled>ÁFA-kulcs</option>
                    <option value="9" disabled>Deviza</option>
                    <option value="10" disabled>Árfolyam</option>
                    <option value="11" disabled>Fizetési mód</option>
                  </select>
                </span>
              </div>
            </ion-button>
            <ion-button [color]="menu!=1 ? 'light' : 'primary'" disabled>
              <div class="custom-button-content">
                <img src="assets/icon/icons8-general-ledger-96.png" width="50px">
                <span>Könyvelés<br>
                  <select name="nezet" [(ngModel)]="menu" (change)="menuChange(0)">
                    <option value="0">-</option>
                    <option value="2" >Könyvelés</option>
                    <option disabled>──────────</option>
                    <option value="3" >Vevő</option>
                    <option value="4" >Szállító</option>
                    <option value="5" >Bank</option>
                    <option value="6" >Vegyes</option>
                    <option disabled>──────────</option>
                    <option value="7" >Közösségen belüli</option>
                    <option value="8" >Fordított ÁFA</option>
                    <option value="9" >Kapott előleg</option>
                    <option value="10" >Adott előleg</option>
                    <option disabled>──────────</option>
                    <option value="11" >Banki kivonat import</option>
                  </select>
                </span>
              </div>
            </ion-button>
            <ion-button [color]="menu!=2 ? 'light' : 'primary'">
              <div class="custom-button-content">
                <img src="assets/icon/icons8-statistics-96.png" width="50px">
                <span>Statisztika<br>
                  <select name="nezet" [(ngModel)]="menu" (change)="menuChange(2)">
                    <option value="0">-</option>
                    <option value="2" >NAV adófolyószámla</option>
                  </select>
                </span>
              </div>
            </ion-button>
            <ion-button [color]="menu!=3 ? 'light' : 'primary'" disabled>
              <div class="custom-button-content">
                <img src="assets/icon/icons8-item-96.png" width="50px">
                <span>Tárgyi<br>
                  <select name="nezet" [(ngModel)]="menu" (change)="menuChange(0)">
                    <option value="0">-</option>
                    <option value="2">NAV adófolyószámla</option>
                  </select>
                </span>
              </div>
            </ion-button>
            <ion-button [color]="menu!=4 ? 'light' : 'primary'" disabled>
              <div class="custom-button-content">
                <img src="assets/icon/icons8-invoice-96.png" width="50px">
                <span>Számla<br>
                  <select name="nezet" [(ngModel)]="menu" (change)="menuChange(0)">
                    <option value="0">-</option>
                    <option value="2" disabled>Intézményi adatok</option>
                    <option value="3" disabled>Tantermek</option>
                    <option value="4" disabled>Tantárgyak</option>
                    <option value="5" disabled>Osztályok</option>
                    <option value="6" disabled>Csoportok</option>
                    <option value="7" disabled>Tantervek</option>
                    <option value="8" disabled>Eszközök</option>
                    <option value="9" disabled>Csengetési rend</option>
                    <option value="10" disabled>Tanév rendje</option>
                    <option value="11" disabled>Adatszótárak</option>
                    <option value="12">Étkezés beszállítók</option>
                  </select>
                </span>
              </div>
            </ion-button>
            <ion-button [color]="menu!=5 ? 'light' : 'primary'" disabled>
              <div class="custom-button-content">
                <img src="assets/icon/icons8-cash-in-hand-96.png" width="50px">
                <span>Bér<br>
                  <select name="nezet" [(ngModel)]="menu" (change)="menuChange(0)">
                    <option value="0">-</option>
                    <option value="2" disabled>Intézményi adatok</option>
                    <option value="3" disabled>Tantermek</option>
                    <option value="4" disabled>Tantárgyak</option>
                    <option value="5" disabled>Osztályok</option>
                    <option value="6" disabled>Csoportok</option>
                    <option value="7" disabled>Tantervek</option>
                    <option value="8" disabled>Eszközök</option>
                    <option value="9" disabled>Csengetési rend</option>
                    <option value="10" disabled>Tanév rendje</option>
                    <option value="11" disabled>Adatszótárak</option>
                    <option value="12">Étkezés beszállítók</option>
                  </select>
                </span>
              </div>
            </ion-button>
            <ion-button [color]="menu!=6 ? 'light' : 'primary'" disabled>
              <div class="custom-button-content">
                <img src="assets/icon/icons8-cash-96.png" width="50px">
                <span>Pénztár<br>
                  <select name="nezet" [(ngModel)]="menu" (change)="menuChange(0)">
                    <option value="0">-</option>
                    <option value="2" disabled>Intézményi adatok</option>
                    <option value="3" disabled>Tantermek</option>
                    <option value="4" disabled>Tantárgyak</option>
                    <option value="5" disabled>Osztályok</option>
                    <option value="6" disabled>Csoportok</option>
                    <option value="7" disabled>Tantervek</option>
                    <option value="8" disabled>Eszközök</option>
                    <option value="9" disabled>Csengetési rend</option>
                    <option value="10" disabled>Tanév rendje</option>
                    <option value="11" disabled>Adatszótárak</option>
                    <option value="12">Étkezés beszállítók</option>
                  </select>
                </span>
              </div>
            </ion-button>
            <ion-button [color]="menu!=7 ? 'light' : 'primary'" disabled>
              <div class="custom-button-content">
                <img src="assets/icon/icons8-lock-96.png" width="50px">
                <span>Zárás és nyitás<br>
                  <select name="nezet" [(ngModel)]="menu" (change)="menuChange(0)">
                    <option value="0">-</option>
                    <option value="2" disabled>Intézményi adatok</option>
                    <option value="3" disabled>Tantermek</option>
                    <option value="4" disabled>Tantárgyak</option>
                    <option value="5" disabled>Osztályok</option>
                    <option value="6" disabled>Csoportok</option>
                    <option value="7" disabled>Tantervek</option>
                    <option value="8" disabled>Eszközök</option>
                    <option value="9" disabled>Csengetési rend</option>
                    <option value="10" disabled>Tanév rendje</option>
                    <option value="11" disabled>Adatszótárak</option>
                    <option value="12">Étkezés beszállítók</option>
                  </select>
                </span>
              </div>
            </ion-button>
            <ion-button [color]="menu!=8 ? 'light' : 'primary'" disabled>
              <div class="custom-button-content">
                <img src="assets/icon/nav-logo.svg" width="50px" height="50px">
                <span>Adatszolgáltatás<br>
                  <select name="nezet" [(ngModel)]="menu" (change)="menuChange(0)">
                    <option value="0">-</option>
                    <option value="2" >TEL</option>
                    <option value="3" >'08</option>
                    <option value="4" >eÁFA</option>
                    <option value="5" >'T101</option>
                    <option value="6" >'58</option>
                  </select>
                </span>
              </div>
            </ion-button>
            <ion-button [color]="menu!=9 ? 'light' : 'primary'" disabled>
              <div class="custom-button-content">
                <img src="assets/icon/icons8-settings-96.png" width="50px">
                <span>Szervíz<br>
                  <select name="nezet" [(ngModel)]="menu" (change)="menuChange(0)">
                    <option value="0">-</option>
                    <option value="2" disabled>Intézményi adatok</option>
                    <option value="3" disabled>Tantermek</option>
                    <option value="4" disabled>Tantárgyak</option>
                    <option value="5" disabled>Osztályok</option>
                    <option value="6" disabled>Csoportok</option>
                    <option value="7" disabled>Tantervek</option>
                    <option value="8" disabled>Eszközök</option>
                    <option value="9" disabled>Csengetési rend</option>
                    <option value="10" disabled>Tanév rendje</option>
                    <option value="11" disabled>Adatszótárak</option>
                    <option value="12">Étkezés beszállítók</option>
                  </select>
                </span>
              </div>
            </ion-button>
            <!--ion-button [color]="menu!=2 ? 'light' : 'primary'" (click)="menuChange(2)" style="min-width: 100px;" >
              <div class="custom-button-content">
                <img src="assets/icon/icons8-money-96.png" width="50px">
                <span>Bizonylatok<br>
                  <select name="nezet" style="visibility: hidden;">
                    <option value="0">-</option>
                  </select>
                </span>
              </div>
            </ion-button-->
          </div>
        </div>


      </ion-col>
    </ion-row>

    <!--ion-card color="primary" class="ion-color ion-color-primary md hydrated" *ngIf="loginmode=='gondviselo'">
      <ion-card-header class="ion-inherit-color md hydrated">
        <ion-card-title class="ion-inherit-color md hydrated">
          <ion-icon name="alert-circle-outline" class="md hydrated"></ion-icon>
          <span *ngIf="egyenleg.egyenleg == -1">Nincs felhasználható egyenleg</span>
          <span *ngIf="egyenleg.egyenleg != -1">Egyenleg: {{egyenleg.egyenleg}} Ft</span>
        </ion-card-title>
        <ion-card-subtitle class="ion-inherit-color md hydrated">

        </ion-card-subtitle>
      </ion-card-header>
    </ion-card-->
  

    <router-outlet></router-outlet>




  </ion-grid>

</ion-content>